<template>
  <div class="card">
    <div :class="['cardBox', `cardBoxBg-${brandCode}`]" ref="imageWrapper">
      <div class="bgBox">
        <div class="name">
          {{ empInfo.wordType ? empInfo.empName : empInfo.empNameCn }}
        </div>
        <!-- <div class="name">{{empInfo.empNameEn}}</div> -->
        <div class="position">
          {{ empInfo.wordType ? empInfo.titleComplex : empInfo.titleCn }}
        </div>
        <img class="code" :src="qrCode" alt />
        <div class="subtitle">{{ subtitleMap[brandCode] }}</div>
        <div class="company">{{ empInfo.wordType ? orgNameCn : orgName }}</div>
        <div class="bottomInfo">
          <div class="item item-break">
            {{ empInfo.wordType ? shopAddressCn : shopAddress }}
          </div>
          <div class="item">{{ empInfo.phone }}</div>
          <!-- <div class="item">{{empInfo.mobile}}</div> -->
          <div class="email">{{ empInfo.email }}</div>
        </div>
        <!-- <div
          class="bottomBtm"
          :style="{ color: brandCode === 'PRO' ? '#c9bc9c' : '#fafafa' }"
        >
          {{ urlMap[brandCode] }}
        </div> -->
      </div>
    </div>
    <!-- 显示内容 -->
    <div class="imgBox">
      <img :src="dataURL" class="cardImg" alt />
    </div>
    <div class="tip">
      <div>长按保存图片至相册后</div>
      <div>请用微信扫一扫</div>
      <div>添加您的专属珠宝顾问</div>
    </div>
    <div class="btnBox" @click="backPage()">
      <div class="btn">返回</div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
export default {
  name: "card",
  data () {
    return {
      dataURL: "",
      empInfo: {},
      qrCode: "",
      brandCode: "CSS",
      shopAddress: "",
      orgName: "",
      urlMap: {
        'CSS': 'www.chowsangsang.com',
        'EMP': 'www.emphasis.com',
        'ES': 'chowsangsang.com',
        'MB': 'www.chowsangsang.com/Marco-Bicego',
        'MG': 'cn.chowsangsang.com/MintyGreen',
        'MG-MC': 'www.chowsangsang.com',
        'MG-OC': '', // 在图片中显示文字
        'RT': 'www.chowsangsang.com/rolex',
        'RX': 'www.chowsangsang.com/rolex',
        'TU': 'www.chowsangsang.com/tudor',
        'PRO': 'promessa.com.cn',
      },
      subtitleMap: {
        'EMP': '周生生集团旗下品牌',
        'MB': '周生生独家代理品牌',
        'PRO': '周生生集团旗下品牌'
      }
    };
  },
  async created () {
    await this.$api.user.getToken({
      userId: "cssUat",
      clientId: "cssUat1"
    });

    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if (this.$route.query.brandCode != this.brandCode) {
      this.brandCode = this.$route.query.brandCode;
    }

    let queryByOrgCode = await this.$api.user.queryByOrgCode(
      this.$route.query.orgCode || 609 || this.$route.query.orgCode
    );
    if (!Object.keys(queryByOrgCode).length) {
      this.$toast("暂无店长信息");
      this.backPage();
      return;
    }
    // console.log('========>>>queryByOrgCode', queryByOrgCode)
    this.empInfo = queryByOrgCode.empInfo && queryByOrgCode.empInfo[0];
    this.shopAddress = this.$route.query.address;
    this.shopAddressCn = this.$route.query.addressCn;

    this.qrCode =
      queryByOrgCode.WXEmployee &&
      queryByOrgCode.WXEmployee.qrCodeToBase64;
    this.orgName = this.$route.query.orgName;
    this.orgNameCn = this.$route.query.orgNameCn;
    this.$nextTick(function () {
      this.productionImage();
    });
    console.log("queryByOrgCode", queryByOrgCode);
    this.weixinOAuth2();
  },
  mounted () { },

  methods: {
    productionImage () {
      // 手动创建一个 canvas 标签
      // const canvas = document.createElement("canvas");
      // 获取父标签，意思是这个标签内的 DOM 元素生成图片
      let canvasBox = this.$refs.imageWrapper;
      // // 获取父级的宽高
      // const width = parseInt(window.getComputedStyle(canvasBox).width);
      // const height = parseInt(window.getComputedStyle(canvasBox).height);
      // // 宽高 * 2 并放大 2 倍 是为了防止图片模糊
      // // 获取像素比
      const scaleBy = this.DPR();
      // canvas.width = width * scaleBy;
      // canvas.height = height * scaleBy;
      // canvas.style.width = width + "px";
      // canvas.style.height = height + "px";
      // const context = canvas.getContext("2d");
      // context.scale(scaleBy, scaleBy);
      const options = {
        // backgroundColor: null,
        // canvas: canvas,
        scale: scaleBy,
        useCORS: true
        // width:width+'px',
        // height:height+'px',
      };
      html2canvas(canvasBox, options).then(canvas => {
        // toDataURL 图片格式转成 base64
        let dataURL = canvas.toDataURL("image/png");
        // this.downloadImage(dataURL);
        this.dataURL = dataURL;
        // console.log("dataURL", dataURL);
      });
    },
    /**
     * 根据window.devicePixelRatio获取像素比
     */
    DPR () {
      if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
      }
      return 1;
    },
    backPage () {
      if (this.$route.query.goindex === "true") {
        this.$router.push("/");
      } else {
        this.$router.back(-1);
      }
    },
    /**
     * @author yihan.zhang
     * 微信登陆，提交code与state
     * @returns {Promise<void>}
     */
    async weixinOAuth2 (getLocation = {}) {
      // 判断是否在微信中
      let code = localStorage.getItem("WEIXIN_OAUTH2_CODE");
      let state = localStorage.getItem("WEIXIN_OAUTH2_STATE");
      localStorage.removeItem('WEIXIN_OAUTH2_CODE');
      localStorage.removeItem('WEIXIN_OAUTH2_STATE');
      if (code && state) {
        // 保存用户信息
        console.log('提交微信用户数据中', code, state, getLocation);
        localStorage.setItem("WEIXIN_OAUTH2_IS", "TRUE");
        result = await this.$api.user.saveWeixinUser({
          code: code,
          state: state,
          cnLatitude: getLocation.lat || "",
          cnLongitude: getLocation.lng || "",
          city: getLocation.city || "",
          province: getLocation.province || ""
        })
        console.log('微信用户信息保存结果', result);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding-top: 1px;
}
.imgBox {
  box-shadow: 0 0 0.25rem #bbb;
  width: 5.76rem;
  margin: 0 auto;
  font-size: 0;
  margin-top: 0.3rem;
  min-height: 135vw;
  border-radius: 6px;
  .cardImg {
    width: 100%;
    border-radius: 6px;
  }
}
.tip {
  text-align: center;
  font-size: 0.3rem;
  margin-top: 0.3rem;
  color: #bbb;
}
.btnBox {
  width: 5.76rem;
  height: 0.85rem;
  display: flex;
  justify-content: center;
  margin: 0.6rem auto;
  .btn {
    font-size: 0.26rem;
    font-weight: 400;
    color: rgba(250, 250, 250, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(201, 188, 156, 1);
    width: 2.8rem;
  }
}
.cardBoxBg- {
  background-image: url("../assets/bg-CSS.jpg");
}
.cardBoxBg-CSS {
  background-image: url("../assets/bg-CSS.jpg");
}
.cardBoxBg-EMP {
  background-image: url("../assets/bg-EMP.jpg");
}
.cardBoxBg-ES {
  background-image: url("../assets/bg-ES.jpg");
}
.cardBoxBg-PRO {
  background-image: url("../assets/bg-PRO.jpg");
}
.cardBoxBg-MB {
  background-image: url("../assets/bg-MB.jpg");
}
.cardBoxBg-MG {
  background-image: url("../assets/bg-MG.jpg");
}
.cardBoxBg-MG-MC {
  background-image: url("../assets/bg-CSS.jpg");
}
.cardBoxBg-MG-OC {
  background-image: url("../assets/bg-MG.jpg");
}
.cardBoxBg-RT {
  background-image: url("../assets/bg-RT.jpg");
}
.cardBoxBg-RX {
  background-image: url("../assets/bg-RX.jpg");
}
.cardBoxBg-TU {
  background-image: url("../assets/bg-TU.jpg");
}

.cardBox {
  width: 576px;
  height: 1032px;
  border-radius: 12px;
  text-align: center;
  // position: relative;
  position: fixed;
  left: 0px;
  top: -2000px;
  font-size: 0;
  background-size: 100%;
  .bgBox {
    margin-top: 240px;
    padding: 45px;
  }
  .name {
    font-size: 37px;
    font-weight: 800;
    color: rgba(0, 0, 0, 1);
  }
  .position {
    font-size: 23px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    margin-top: 35px;
  }
  .code {
    width: 123px;
    margin-top: 105px;
  }
  .subtitle {
    height: 35px;
    font-size: 26px;
    font-weight: 500;
    color: rgba(49, 49, 49, 1);
    margin-top: 90px;
  }
  .company {
    font-size: 23px;
    font-weight: 500;
    color: rgba(49, 49, 49, 1);
    margin-top: 10px;
  }
  .bottomInfo {
    margin: 10px auto;
    font-size: 18px;
    font-weight: 400;
    color: rgba(49, 49, 49, 1);
    text-align: center;
    padding: 0 20px;

    .item {
      margin-bottom: 5px;
      &.item-break {
        word-break: break-all;
      }
    }
  }
  .bottomBtm {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 576px;
    height: 61px;
    text-align: center;
    line-height: 61px;
    font-size: 23px;
    font-weight: 400;
    color: rgba(250, 250, 250, 1);
  }
}
</style>
